import { render, staticRenderFns } from "./DetailSection.vue?vue&type=template&id=2e4d6011&scoped=true&lang=pug&"
import script from "./DetailSection.vue?vue&type=script&lang=js&"
export * from "./DetailSection.vue?vue&type=script&lang=js&"
import style0 from "./DetailSection.vue?vue&type=style&index=0&id=2e4d6011&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4d6011",
  null
  
)

export default component.exports